import { jsonProperty, Serializable } from "ts-serializable";
import Unit from "../unit/Unit";

class AgendaMesDia extends Serializable{
    @jsonProperty(String, null)
    agendaId: string | null = null;

    @jsonProperty(String, null)
    turnoDiaId: string | null = null;

    @jsonProperty(String, null)
    data: string | null = null;

    @jsonProperty(String, null)
    horaInicio: string | null = null;

    @jsonProperty(String, null)
    horaFim: string | null = null;

    @jsonProperty(String, null)
    unidadeAtendimentoId: string | null = null;

    @jsonProperty(Unit, null)
    unit: Unit | null = null;

    @jsonProperty(Boolean)
    inativo: Boolean = false;

    @jsonProperty(Boolean)
    ativavel: Boolean = false;

    @jsonProperty([Object], null)
    proporcoes: Object[] | null = []

}

export default AgendaMesDia;